import {FC, createContext, useState, useEffect, ReactNode, Dispatch, SetStateAction} from 'react'
import {User, initialUser}  from '../core/_models'
import {getUser}  from '../core/_requests'


type UserContextProps = {
  user: User|undefined
  setUser: Dispatch<SetStateAction<User|undefined>>
  isLoading: boolean
}

type UserProviderProps = {
  children: ReactNode
  userId: string|undefined
}

const UserContext = createContext<UserContextProps>({
  user: initialUser,
  setUser: () => {},
  isLoading: true
})

const UserProvider: FC<UserProviderProps> = ({ children, userId }) => {
  const [user, setUser] = useState<User|undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const loadUser = async () => {
    setIsLoading(true)
    try {
      setUser(await getUser(userId))
    } catch (e: any) {
      console.log('Fail loading user', e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadUser()
  }, [userId])

  if (isLoading) {
    return (<>IS loading ...</>)
  }


  if (!isLoading && user === undefined) {
    return (<>No user</>)
  }

  return (
    <UserContext.Provider value={{ user, setUser, isLoading }}>
      {children}
    </UserContext.Provider>
  )
}

export {UserContext, UserProvider}
